import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import SearchBar from '../SearchBar';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material';
import { useTheme } from '@mui/material';
import { SearchWithDropdownProps } from './types';

const SearchWithDropdown = ({
  placeholder,
  options,
  selectedOption,
  selectChange,
  onChange,
  disabled,
  onClear,
  value,
  ...props
}: SearchWithDropdownProps) => {
  const { palette } = useTheme();

  const handleSelectChange = (event: SelectChangeEvent<unknown>) => {
    selectChange(event.target.value as string);
  };
  const disabledColor = palette.colors.grey[400];

  return (
    <Box display='flex'>
      <StyledSelect
        IconComponent={props => (
          <KeyboardArrowDown
            {...props}
            sx={{
              fill: disabled ? disabledColor : palette.common.black,
            }}
          />
        )}
        onChange={handleSelectChange}
        value={selectedOption}
        disabled={disabled}
        sx={{
          '&.Mui-disabled': {
            backgroundColor: palette.colors.slate[100],
          },
        }}
      >
        {options.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.text}
          </MenuItem>
        ))}
      </StyledSelect>
      <SearchBar
        {...props}
        onClear={onClear}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        sx={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          '&.Mui-disabled, &.Mui-disabled:hover': {
            backgroundColor: palette.colors.slate[100],
          },
          '&.Mui-disabled:hover': {
            'fieldset.MuiOutlinedInput-notchedOutline': {
              borderColor: disabledColor,
            },
            svg: {
              color: disabledColor,
            },
          },
        }}
        size='small'
        value={value}
      />
    </Box>
  );
};

const StyledSelect = styled(Select)`
  .MuiSelect-select {
    padding: 8px 52px 8px 8px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: -0.1px;
  }
  fieldset {
    border-right-width: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export default SearchWithDropdown;
